import axios from 'axios';
import isString from 'lodash/isString';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { StatusCodes } from 'http-status-codes';
import { BadRequestError, InternalServerError } from '../util/error';
import { getSessionTokenHeader } from '../util/util';

import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';

export default async function makeRequest(
  url,
  { headers = {}, method = 'get', params, data, fullResponse = false, skipErrorProcessing = false, ...options } = {}
) {
  if (!isString(url)) {
    throw new Error('A URL is required');
  }

  try {
    const sessionTokenHeader = await getSessionTokenHeader();

    const config = {
      headers: {
        ...headers,
        ...sessionTokenHeader,
      },
      method,
      url,
      ...pickBy({
        params,
        data,
      }),
      ...options,
    };

    const response = await axios(config);

    if (response.status === StatusCodes.NO_CONTENT) {
      return;
    }

    if (fullResponse) {
      return pick(response, ['data', 'headers', 'status', 'statusText']);
    }

    return response.data;
  } catch (err) {
    if (skipErrorProcessing) {
      throw err;
    }

    if (err?.response?.data?.code === SimplrErrors.Codes.WEAK_PASSWORD) {
      throw createHttpError({ status: err.response.data.status, data: err.response.data });
    }

    if (err.response) {
      const message = err.response.data?.error?.message || err.response.data?.message;
      if (message) {
        throw createHttpError({ status: err.response, data: message });
      } else {
        throw createHttpError(err.response);
      }
    }

    throw err;
  }
}

export function createHttpError({ status, data }) {
  switch (status) {
    case StatusCodes.BAD_REQUEST:
      return new BadRequestError(data);
    case StatusCodes.INTERNAL_SERVER_ERROR:
      return new InternalServerError(data);
    default:
      const message = isString(data) ? data : JSON.stringify(data);

      return new Error(message);
  }
}
